export const rotaFilterConfig = [
  {
    id: 'CodigoIntegracao',
    type: 'text',
    label: 'Código de Integração',
    placeholder: 'Digite o código de integração',
  },
  {
    id: 'Descricao',
    type: 'text',
    label: 'Descrição',
    placeholder: 'Digite a descrição da rota',
  },
];
